<div class="footer bg-white py-4 text-center" id="kt_footer">
	<div class="container">
		<div class="text-muted">
			Thank you for using CPD Portfolio.
		</div>
	</div>
</div>